import { successResponseMockStructure } from './successResponseMockStructure'

import { UserDiscountsList } from '~types/user'

export const discount: UserDiscountsList = [
  {
    id: '3a4c543b-09c5-40bd-a929-d15d5e127f52',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'GKUQM1663654319985',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '6a5e9532-3840-4c2d-86ac-a050f4d97a00',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'RHAII1664361475659',
    points: '100',
    type: 1,
    value: '10',
    status: 0,
  },
  {
    id: '1b5c68aa-d372-49e3-8b2a-f23dad65f819',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'CFPTO1664362490051',
    points: '50',
    type: 0,
    value: '92',
    status: 0,
  },
  {
    id: '4b9e08ca-8a13-4140-8dba-0001a7a78a84',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'IKAIB1664362500865',
    points: '50',
    type: 0,
    value: '92',
    status: 0,
  },
  {
    id: '01329912-5104-4f71-948a-874ea218af84',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'WUJME1664363317283',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'b5e8f319-e5db-4de9-a3f4-918453ff1b53',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'ADUUB1664364147832',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '98e3dcef-c1de-4aab-9824-7d0406658b58',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'VZVZG1664364347565',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'eb631452-90be-4d4e-8e75-6cabadc89987',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'VTJID1664364405446',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '2da9f779-850d-4026-bb69-7ee85a986977',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'LOBSN1664365440828',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'b7505d25-11d3-4264-afc8-2fc45903ff07',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'SPIKY1664365560530',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '28b8eb71-683c-450d-9706-8ff96087ffd4',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'WRCIW1664368835112',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '54eb7136-3add-49c6-9c48-a257a2a0c90c',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: null,
    code: 'QRNQQ1664368909689',
    points: '50',
    type: 0,
    value: '92',
    status: 0,
  },
  {
    id: 'b2a909b8-acb8-48e0-b19f-713360f9fae0',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'CNYSE1664433594097',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '1c6bd405-d795-4baf-8f89-dd149a5318c4',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'OMVPW1664434111568',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '6bb9b2cc-ee14-485a-badd-119e4958da89',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'QVZOT1664434171773',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '78082d6c-abf8-41d6-a45f-3536bde45a66',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'KSUKK1664435582456',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'cc7c4be0-e400-4d5e-bdbc-2a89bb6009b8',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'QQSJZ1664435756404',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '22b500bb-e8a6-4f48-a0b5-77445ebc69e4',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'CLHBP1664435758057',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '2bbcbb7b-f706-401a-b889-9e79e70997c7',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '01454f09-2ac8-4cc0-8e2b-fbfe147be486',
    code: 'KCSGD1664437233968',
    points: '100',
    type: 1,
    value: '10',
    status: 0,
  },
  {
    id: 'b16ec73a-b6a2-4986-9d5b-042c14e7e38b',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'DUZIF1664437353088',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'ae66a5f3-2ce9-4b96-a979-be66b695b6ba',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '92078628-fe36-498f-b869-0964636f1566',
    code: 'MOUDM1664437408906',
    points: '50',
    type: 0,
    value: '92',
    status: 0,
  },
  {
    id: 'fddedbdb-d0de-4563-a30d-9d5f6788e768',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '92078628-fe36-498f-b869-0964636f1566',
    code: 'TAVUM1664437410047',
    points: '50',
    type: 0,
    value: '92',
    status: 0,
  },
  {
    id: 'bdd649be-7210-4041-bba8-e4b1f846e1c9',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '92078628-fe36-498f-b869-0964636f1566',
    code: 'PDSAJ1664437410880',
    points: '50',
    type: 0,
    value: '92',
    status: 0,
  },
  {
    id: '7211c3a4-70fd-4516-bdfa-cb68afdbe4f0',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '92078628-fe36-498f-b869-0964636f1566',
    code: 'KCVJD1664437638617',
    points: '50',
    type: 0,
    value: '92',
    status: 0,
  },
  {
    id: '36427d38-b48a-44a0-a36e-9ea1996fb005',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'LYLNG1664437656064',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'add119ba-4370-4d92-b7fb-050267b14dd3',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'IGKLW1664437657563',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'b41abc0f-2d7d-43fd-8e85-3299ed9b5d3e',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'SORZV1664437663088',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'fb12d847-31e0-4fa6-9ee9-7ea35c6e5c99',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'YTQNF1664523109371',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '4a83d025-ebfe-483e-9f59-192329b5d75a',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'RHQTF1664523151691',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '8ee620db-2964-4a45-b46a-0a84773bd366',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'BMYSO1664523676783',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '9d79d18e-65a4-408a-b0f5-a9e979eae132',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'DFVNH1664523683697',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '50fa69a0-3548-4e82-b91e-075e986f1f0b',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'GFBZT1664523687253',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '69fdfe32-d78a-4dc2-8edc-29737a3447f7',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'NJBEC1664523812327',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '3709e16a-3c23-4b71-b65c-7974800ca86b',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '21a34422-369e-4378-939f-6e25078b6429',
    code: 'NPCJM1664523929595',
    points: '250',
    type: 0,
    value: '60',
    status: 0,
  },
  {
    id: '70296456-312c-4389-9f8e-92e790e586f9',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    code: 'GVEBG1664540634307',
    points: '100',
    type: 1,
    value: '25',
    status: 0,
  },
  {
    id: '3f35dc92-9c7b-48f2-9c43-dd44f51ce8fa',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '21a34422-369e-4378-939f-6e25078b6429',
    code: 'PWUGP1664540655779',
    points: '250',
    type: 0,
    value: '60',
    status: 0,
  },
  {
    id: '8b762f22-2677-49c6-85eb-4327807c7b1c',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'XXSTU1664541915086',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '31c177f2-6bc7-4c6a-acdd-7d6a93af6cf3',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'HKPGM1664541926090',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '67c5de94-0bd2-42a2-945e-3ebd18b05f16',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'RMFFI1664542115133',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '329d4ef9-3378-4d14-8565-e3e520417378',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '29164842-70b6-4f28-8af5-45ef39b38895',
    code: 'KOKEM1664543180649',
    points: '100',
    type: 0,
    value: '75',
    status: 0,
  },
  {
    id: '1dd5ebe3-259e-4174-8344-b710c47e72e0',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'GQWXC1664546780452',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: '165d31c8-578e-41f4-bc9a-a9d899673357',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: 'a57ca08d-6cc1-4144-a368-bfcb2e698dd5',
    code: 'YDCKW1664546814040',
    points: '50',
    type: 0,
    value: '10',
    status: 0,
  },
  {
    id: 'a16fab6e-3006-40d7-bb91-e6dec5201567',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '0fe4f474-5b41-48aa-b0d4-010943c24fa3',
    code: 'MBZGP1664617214041',
    points: '50',
    type: 0,
    value: '5',
    status: 0,
  },
  {
    id: 'b63dca4f-3c1a-4e5f-b9f4-207057d3f005',
    userId: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
    storeId: '44580859-b5b0-4d21-8a3d-388f3f7c8a22',
    offerId: '2cec1dd6-6cc4-483d-a744-4d966aff9189',
    code: 'JXHDK1664784512206',
    points: '50',
    type: 0,
    value: '11',
    status: 0,
  },
]

export const mockDiscountResponse = successResponseMockStructure({ discount })
